module.exports = __webpack_public_path__ + "img/22_windAndRain_zx.fea8e6f1.png";